import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import StandardLayout from '../../../../../../components/Layout/StandardLayout';
import AutoReminderSettings from '../../../../../../components/Layout/AutoReminders/AutoReminderSettings';

const ROLEX_INQUIRY_TYPE = 'rolexInquiry';
const ROLEX_INQUIRY_LIST_ITEM_ID = 'default';

const ASSIGNMENT_OPTIONS = [
  { label: 'Associate assigned to the inquiry', value: 'inquiry' },
  { label: "Client's primary associate", value: 'assignment' },
];

const InquiryAutoReminder = props => {
  const history = useHistory();

  const modifiedMatch = {
    ...props.match,
    params: {
      ...props.match.params,
      listItemId: ROLEX_INQUIRY_LIST_ITEM_ID,
    },
  };

  const setRedirectBack = () => {
    history.push('/Configuration/rolex');
  };

  const reminderNameHandler = () => {
    if (props.autoRemMsgs.reminderName.length > 20) {
      return `${props.autoRemMsgs.reminderName.substring(0, 19)}...`;
    }
    return props.autoRemMsgs.reminderName;
  };

  return (
    <StandardLayout
      title={`${props.autoRemMsgs.reminderAddOrEdit} Auto Reminder`}
      description="Create an auto reminder for inquiry follow-ups"
      breadCrumbs={[
        { title: 'Configuration' },
        { title: 'Rolex Inquiry', to: '/Configuration/rolex' },
        {
          title:
            props.autoRemMsgs.reminderAddOrEdit === 'Add'
              ? `${props.autoRemMsgs.reminderAddOrEdit} Auto Reminder`
              : `${props.autoRemMsgs.reminderAddOrEdit} "${reminderNameHandler()}"`,
        },
      ]}
      classProps="standard-width-with-sidebar"
    >
      <AutoReminderSettings
        setRedirectBack={setRedirectBack}
        cancelRoute="/Configuration/rolex"
        descriptionText="When do you want the associate to be reminded?"
        popConfirmDesc="This will remove the reminder from inquiry follow-ups"
        editRoute="/Configuration/rolex"
        type={ROLEX_INQUIRY_TYPE}
        match={modifiedMatch}
        assignmentOptions={ASSIGNMENT_OPTIONS}
      />
    </StandardLayout>
  );
};

const mapStateToProps = state => ({
  ...state.auth,
  autoRemMsgs: state.autoRemMsgs,
});

export default connect(mapStateToProps, {})(InquiryAutoReminder);
